import {
  Breadcrumb,
  DownloadExcel,
  ErrorAlert,
  MegaphoneIcon,
  PageHero,
  Table,
  TableRowsPerPage,
  useDebouncedSearch,
  useFetchData,
  useState,
  useTableColumns,
} from "@";

import { getCustomerCampaigns } from "./utils/api";
import { excelHeaderCellsName } from "./utils/options";
import { TableActions, tableColumns } from "./components/TableOptions";

const Index = () => {
  const [search, setSearch] = useState(""); // search query
  const links = [{ name: "حملات العملاء", link: "" }];

  // Define table columns with actions
  const columns = useTableColumns(tableColumns, (row) => (
    <TableActions row={row} />
  ));

  // Fetch data hook
  const { data, isLoading, error, pg, fetchData, updatePg } = useFetchData({
    fun: getCustomerCampaigns,
    params: [search],
  });

  useDebouncedSearch(fetchData, search);

  return (
    <>
      {/* Error alert */}
      <ErrorAlert reload={fetchData} show={error} />
      {/* Breadcrumb navigation */}
      <Breadcrumb links={links} />

      <main className="table-card relative">
        <PageHero
          eyebrow="المتبرعين / الحملات"
          title="حملات العملاء"
          count={pg.rows}
          icon={MegaphoneIcon}
          hideCount={isLoading}
          headerClassName="flex-row items-center justify-between"
        >
          <input
            className="single-search-input"
            onChange={(e) => setSearch(e.target.value)}
            placeholder="بحث"
            value={search}
            type="search"
          />

          <TableRowsPerPage
            pagination={pg}
            onRowsPerPageChange={(size) => updatePg({ size: size })}
          />
          <DownloadExcel
            headerCellsName={excelHeaderCellsName}
            fetch={getCustomerCampaigns}
            search={search.values}
            length={data?.length}
          />
        </PageHero>

        {/* Table */}
        <Table
          data={data}
          pagination={pg}
          isLoading={isLoading}
          columns={columns}
          pageChange={(page) => updatePg({ page: page })}
          perRowsChange={(size) => updatePg({ size: size })}
        />
      </main>
    </>
  );
};

export default Index;
